/**
 * =============================================================================
 * upsell.js
 * =============================================================================
 * Upsell functionality
 * =============================================================================
 */

var Upsell = {
  container: undefined,
  sectionId: undefined, // ID of the upsell modal section, so we know what section to request via fetch

  enabled: undefined,

  /**
   * Initialisation
   */
  init: function() {
    this.container = document.getElementById("upsell-container");
    if(!this.container){
      return;
    }
    if(!this.enabled){
      return;
    }
    
    this.sectionId = this.container.dataset.sectionId;

    this.setupEventListeners();

    console.log("[U] Initialised");
  },

  /**
   * Setup event listeners
   */
  setupEventListeners: function() {
    let addForms = this.container.querySelectorAll(".upsell-add-form");
    addForms.forEach(addForm => {
      addForm.addEventListener("submit", this.onAddUpsell.bind(this));
    });
  },

  /**
   * Allow others to trigger the upsell modal
   */
  show: function() {
    // Update it (so it's based on the last item added to cart)
    const sectionedUrl = `${window.location.href}?section_id=${this.sectionId}`;
    this.renderSectionFromFetch(sectionedUrl, event).then(e => {
      try {
        let upsellModal = new bootstrap.Modal(document.getElementById('modal-bundle-builder'), {});
        upsellModal.toggle();
      } catch (e) {
        console.log('[U] Error showing modal', e);
      }
    });
  },

  /**
   * Add the upsell to the cart, and re-render the upsell modal
   * @param {Event} event The initiating event
   */
  onAddUpsell: function(event) {
    event.preventDefault();
    let form = event.target;
    if(!form.reportValidity()){
      return;
    }
    let formData = new FormData(form);
    for (var pair of formData.entries()) {
      console.log(pair[0]+ ', ' + pair[1]); 
    }
    this.container.querySelector('#results-loading').classList.remove('d-none');
    window.disableNextMinicartOpen = true;

    // Add upsell to the cart, then re-render the modal contents
    MP.Extensions.Cart.add(formData).finally(e => {
      // Re-render the section 
      const sectionedUrl = `${window.location.href}?section_id=${this.sectionId}`;
      this.renderSectionFromFetch(sectionedUrl, event);
    });
  },

  /**
   * Fetch the section and re-render
   * @param {String} url URL to fetch and render 
   */
  renderSectionFromFetch: function(url) {
    return fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        let parsedHtml = new DOMParser().parseFromString(html, 'text/html');
        document.getElementById("modal-bundle-builder-content").innerHTML = parsedHtml.getElementById("modal-bundle-builder-content").innerHTML;
        this.setupEventListeners();
        mp_lazyload_setup();
      });
  }
}

export default Upsell;